import { render, staticRenderFns } from "./ConfigurationForm.vue?vue&type=template&id=360fc9af&"
import script from "./ConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./ConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('360fc9af')) {
      api.createRecord('360fc9af', component.options)
    } else {
      api.reload('360fc9af', component.options)
    }
    module.hot.accept("./ConfigurationForm.vue?vue&type=template&id=360fc9af&", function () {
      api.rerender('360fc9af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/ConfigurationForm.vue"
export default component.exports